import React from "react";
import { useContext } from "react";
import { MyContext } from "../context/context";

const About = () => {
  const { languageData } = useContext(MyContext);

  return (
    <section
      id="about"
      className="grid max-w-6xl my-20 text-black md:mx-4 lg:mx-auto lg:space-y-0 lg:grid-cols-2"
    >
      <div
        id="aboutContainer"
        className="flex items-center justify-center bg-black h-[30rem]"
      >
        <img
          id="aboutImage"
          src="/images/logo.png"
          alt=""
          className="w-[22rem] h-[23rem]"
        ></img>
      </div>

      <div className="p-4 bg-yellow-400 md:px-4">
        <h3 className="p-2 text-4xl font-bold text-white w-max">
          {languageData?.aboutTitle}
        </h3>

        <p className="p-2 leading-[1.65rem] text-black">
          {languageData?.aboutText}
        </p>
      </div>
    </section>
  );
};

export default About;
